import React, { useRef, useState, useEffect, useContext } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert, Dropdown } from "react-bootstrap";
import {setUrlParam, timeAgo} from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import energyTypes from "../data/energyTypes";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import UserMenu		from "../components/UserMenu";
import {formatDate} from  "../utils/functions";
import DialogScreeningMap from "../layouts/DialogScreeningMap";
import InfoLayers from "../components/InfoLayers";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import boundaryMode from "../utils/boundaryMode";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import turbineControl from "../utils/turbineControl";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import DialogProject from "../layouts/DialogProject";
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfBBox from '@turf/bbox';
import { Trash, Copy, FloppyDisk, UploadSimple, Polygon, Plus } from "@phosphor-icons/react";
import EditNow from "../components/EditNow";
import globalContext				from "../utils/globalContext";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax

function Sandbox() {

	const context = useContext(globalContext);

	const center = [24.410699837112105, 59.9885433348754];
	const zoom = 5;

	const [user, setUser] = useState({});
	const [loaded, setLoaded] = useState(false);
	const [newProjectDialog, setNewProjectDialog] = useState({ open: false });
	const [uploadLayerDialog, setUploadLayerDialog] = useState({ open: false });
	const [saveProjectDialog, setSaveProjectDialog] = useState({ open: false });
	const [items, setItems] = useState([]);
	const [selectedMap, setSelectedMap] = useState(false);
	const [map, setMap] = useState(null);
	const [saveBtn, setSaveBtn] = useState(false);

	const mapCont = useRef(null);
	const infoLayerPanel = useRef(null);
	const tc = useRef(null);
	const du = useRef(null);

	const Draw = useRef((() => {
		MapboxDraw.modes.simple_select = { ...MapboxDraw.modes.simple_select, ...limited_simple_select };
		MapboxDraw.modes.direct_select = { ...MapboxDraw.modes.direct_select, ...limited_direct_select };
		return new MapboxDraw({
			displayControlsDefault: false,
			controls: {
				polygon: false,
				line_string: false,
				trash: false,
				boundary_mode: true
			},
			userProperties: true,
			styles: drawTheme,
			modes: Object.assign({ boundary_mode: boundaryMode }, MapboxDraw.modes)
		});
	})());

	useEffect(() => {
		document.title = process.env.REACT_APP_DOC_TITLE;
		document.body.className = "sandbox";

		Promise.all([vindrApi.getToken()])
			.then((res) => {
				return Promise.all([authApi.getUser()]);
			}).then((res) => {
				return Promise.all([
					res[0],
					vindrApi.getUserMaps(res[0].userDetails)
				]);
			}).then((res) => {
				setUser(res[0]);
				setItems(res[1]);
				setLoaded(true);
			}).catch(() => {
				setLoaded(true);
			});
	}, []);

	function getCopy() {
		return structuredClone(items);
	}

	function handleNew(newMap) {
		var swap = getCopy();
		swap.unshift(newMap);
		setItems(swap);
		console.log(swap);
	}

	function handleUpdate(id, newTitle) {
		var swap = getCopy();
		var idx = swap.findIndex((i) => i.id == id);
		if (idx != -1) {
			swap[idx].title = newTitle;
			setItems(swap);
			vindrApi.updateUserMap(swap[idx]);
		}
	}

	function handleCloseMap() {
		setSelectedMap(null);
		setMap(null);
	}

	function handleDropDownClick(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	function handleDuplicate(item) {
		Promise.all([vindrApi.duplicateUserMap(item)])
			.then((res) => {
				if (Array.isArray(res) && res.length && res[0].id)
					handleNew(res[0]);
			}).catch(() => {});
	}

	function handleDelete(item) {
		Promise.all([vindrApi.deleteUserMap(item)])
			.then((res) => {
				var swap = getCopy();
				var idx = swap.findIndex((i) => i.id == item.id);
				if (idx != -1) {
					swap.splice(idx, 1);
					setItems(swap);
				}
			}).catch(() => {});
	}

	function drawProject(e) {
		if (tc.current)
			tc.current.addProject(e);
	}

	function openNewProject() {
		setNewProjectDialog({ open: true });
	}

	function closeNewProject() {
		setNewProjectDialog({ open: false });
	}

	function openUploadLayer() {
		setUploadLayerDialog({ open: true });
	}

	function closeUploadLayer() {
		setUploadLayerDialog({ open: false });
	}

	function openSaveProject(b) {
		setSaveProjectDialog({ open: true, boundary: b });
	}

	function closeSaveProject() {
		setSaveProjectDialog({ open: false });
	}

	function handleSaveProject(e) {
		var fc = du.current.draw.getAll();

		if (!fc.features || !fc.features.length)
			return;

		var b = { ...fc.features[0].geometry };

		if (fc.features[0].geometry.type != 'MultiPolygon') {
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		openSaveProject(b);
	}

	function handleLayerUpload(layer) {
		if (du.current && layer.features && layer.features.length) {
			var feature = { ...layer.features[0] };
			const featureCenter = TurfCenterOfMass(feature.geometry).geometry.coordinates;
			feature.id = 'boundary';
			du.current.draw.add(feature);
			setSaveBtn(true);
			map.fitBounds(TurfBBox(feature));
			map.flyTo({ center: featureCenter });
		}
	}

	return (
		<>
			<div className="header">
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				<div className="middle">
					<Link to="/" className="header-logo">Site Planner</Link>
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr" />
				</div>
				<div className="options">
					{user.userId && <UserMenu user={user} onUpdateUser={(u) => { setUser(u); }} />}
				</div>
			</div>
			<div className="body dashboard2">
				<Sidebar onClick={(e) => { e.stopPropagation(); }}/>
				<div className={"main sandbox "}>
					<Row className="mb-4">
						<Col xl>
						</Col>
					</Row>
					<div className="project-list">
						<Card className="card-project m-4 empty" onClick={() => { openNewProject(); }}>
							<Card.Body className="card-img-top">
								<div><Plus size={72} /></div>
								New map
							</Card.Body>
						</Card>
						{
							items.map((item, k) => {
								return (
								
									<Link className="card-project m-4" key={item.id} to={"/pages/sandbox/" + item.id}>
										<Card.Body className={"card-img-top "} style={{ backgroundImage: "url('" + (item.image ? item.image : '/images/map.png') + "')" }}>
											<Row>
												<Col xl="12" className="text-end">
												
												</Col>
											</Row>
										</Card.Body>
										<Card.Body className="pb-2">
											<Row className="nameBar mb-3">
												<Col xl="10">
													<EditNow id={item.id} key={item.id+""+k} value={item.title} editable={true} onUpdate={(title) => { handleUpdate(item.id, title); }} />
													
												</Col>
												<Col xl="2">
													<Dropdown className="minimal" onClick={(e) => { handleDropDownClick(e); }}>
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<i className="ri-more-2-fill"></i>
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={() => { handleDuplicate(item); }}><Copy size={16} /> Duplicate</Dropdown.Item>
															<Dropdown.Item href="#" onClick={() => { document.getElementById('edit-static-' + item.id).dispatchEvent(new MouseEvent("dblclick", { 'view': window, 'bubbles': true, 'cancelable': true })); }}><Copy size={16} /> Rename</Dropdown.Item>
															<Dropdown.Item href="#" onClick={() => { handleDelete(item); }} className="text-danger"><Trash size={16} /> Delete</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</Col>
											</Row>
											<Row>
												<Col xl="7 text-secondary">
													{item.username}
												</Col>
												<Col xl="5 text-end text-secondary">
													{timeAgo(item.updated)}
												</Col>
											</Row>
										</Card.Body>
									</Link>
								);
							})
						}
					</div>
				</div>
			</div>
			<DialogScreeningMap setup={newProjectDialog} user={user} onSave={(n) => { handleNew(n); }} onClose={() => { closeNewProject(); }} />
			<Loader loaded={loaded} message="Loading projects..." />
		</>
	);
}


export default Sandbox;
